import { executeRequest, Request } from '@jfs/network'
import { getOtpAuthRequestBody } from '../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const getOTPAuthCodeApi = (mobileNo: string, otp: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.generateOtp,
    method: 'POST',
    config: sitConfig(tokens),
    body: getOtpAuthRequestBody(mobileNo, otp),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getOTPAuthCodeApi }
